import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterPipe',
})
export class FilterPipe implements PipeTransform {
  transform(searchObj: any, searchItem: string, defaultFilter: boolean): any {
    if (!searchItem){
      return searchObj;
    }

    if (!Array.isArray(searchObj)){
      return searchObj;
    }

    if (searchItem && Array.isArray(searchObj)) {
      let searchItemKeys = Object.keys(searchItem);

      if (defaultFilter) {
        return searchObj.filter(item =>
            searchItemKeys.reduce((x, keyName) =>
                (x && new RegExp(searchItem[keyName], 'gi').test(item[keyName])) || searchItem[keyName] == "", true));
      }
      else {
        return searchObj.filter(item => {
          return searchItemKeys.some((keyName) => {
            return new RegExp(searchItem[keyName], 'gi').test(item[keyName]) || searchItem[keyName] == "";
          });
        });
      }
    }
  }
}

    // console.log(additionl);
    // if(searchText === undefined) return value ;
    // return value.searchItem(function (searchObj) {
      // return searchObj[additionl].toLowerCase().includes(searchText.toLowerCase());
      // console.log("search", searchObj[additionl].toLowerCase().includes(searchText.toLowerCase()))
    // });
  // }
// }



// WEBPACK FOOTER //
// ./src/pipes/filter/filter.ts